<template>
  <li
    class="tw-flex tw-items-center tw-justify-between tw-border hover:tw-bg-secondary-100 [&:not(:last-child)]:tw-mb-1.5 tw-p-0.5 hover:tw-cursor-grab tw-transition-all"
  >
    <slot />
    <template v-if="isDraggable">
      <span class="tw-mr-1 tw-ml-2 tw-text-dorian-gray-200">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-grip-vertical"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        </svg>
      </span>
    </template>
  </li>
</template>

<script setup lang="ts">
import { useAttrs } from "vue";

const attrs = useAttrs();
const isDraggable = attrs.draggable === "true" || attrs.draggable === true;
</script>
